import Vue from 'vue'
import { VBTooltip } from 'bootstrap-vue/esm/directives/tooltip'
import { ToastPlugin } from 'bootstrap-vue/esm/components/toast'
import { BTooltip } from 'bootstrap-vue'

Vue.directive('tooltip', VBTooltip)
Vue.use(ToastPlugin)
Vue.component('b-tooltip', BTooltip)
